import { HorizontalCardWithTitle as HorizontalCardWithTitleComponent } from './HorizontalCardWithTitle.component';
import { HorizontalCardWithTitleLoader } from './HorizontalCardWithTitleLoader';

/** @deprecated use `Card` instead */
export const HorizontalCardWithTitle = Object.assign(HorizontalCardWithTitleComponent, {
  Loading: HorizontalCardWithTitleLoader,
});
